import { FolderOpen, Upload, HardDrive, Image as ImageIcon } from "lucide-react";
import { PageHeader } from "@/components/admin/PageHeader";
import { ResourceState } from "@/components/admin/ResourceState";
import { useVehicles } from "@/application/hooks/use-vehicles";
import { useI18n } from "@/i18n";

export function MediaPage() {
  const { t } = useI18n();
  const { status, data: vehicles, error, reload } = useVehicles();
  const assets =
    vehicles?.flatMap((v) =>
      v.gallery.map((src, i) => ({ src, name: `${v.id}-${i}.jpg`, size: 1.2 + i * 0.3 })),
    ) ?? [];

  return (
    <div>
      <PageHeader
        title={t.admin.media.title}
        description={t.admin.media.description}
        actions={
          <button className="inline-flex h-9 items-center gap-1.5 rounded-full bg-primary px-4 text-xs font-semibold text-primary-foreground shadow-[var(--shadow-glow)]">
            <Upload className="h-3.5 w-3.5" /> {t.admin.media.upload}
          </button>
        }
      />
      <ResourceState
        status={status}
        error={error}
        onRetry={() => void reload()}
        emptyMessage={t.admin.media.empty}
      >
        <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {[
            { label: t.admin.media.totalAssets, value: assets.length, icon: ImageIcon },
            { label: t.admin.media.storageUsed, value: "2.4 GB", icon: HardDrive },
            { label: t.admin.media.folders, value: "8", icon: FolderOpen },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-2xl border border-border/60 bg-surface-elevated/60 p-4 backdrop-blur"
            >
              <div className="flex items-center justify-between">
                <span className="text-xs uppercase tracking-wider text-muted-foreground">
                  {s.label}
                </span>
                <s.icon className="h-4 w-4 text-primary" />
              </div>
              <div className="mt-2 font-display text-2xl font-semibold">{s.value}</div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
          {assets.map((a, i) => (
            <div
              key={i}
              className="group relative aspect-square overflow-hidden rounded-xl ring-1 ring-border/60"
            >
              <img
                src={a.src}
                alt=""
                className="h-full w-full object-cover transition duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-x-0 bottom-0 translate-y-full bg-gradient-to-t from-background/95 to-transparent p-2 transition group-hover:translate-y-0">
                <div className="truncate font-mono text-[10px]">{a.name}</div>
                <div className="text-[10px] text-muted-foreground">{a.size.toFixed(1)} MB</div>
              </div>
            </div>
          ))}
        </div>
      </ResourceState>
    </div>
  );
}
